module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day02_08_stay-2255ff88849229fcbd10673b837df61c.jpg";